export default `
<section>
  <h2>Juridiskais ietvars
  </h2>
  <p>InnoCAPE (Industrija 4.0: inovāciju ekosistēmas transformācija, izmantojot pakalpojumu sniedzēju kapacitāti) ir
    projekts, ko atbalsta Interreg BSR programma. Atbilstoši projektam tiek uzturēta vietne ar domēnu *
    <a target="_blank" href="https://innocape.eu" rel="noopener noreferrer">.innocape.eu
    </a>.
  </p>
  <section>
    <h3>Vietnes un personas datu apstrādes uzturētājs
    </h3>
    <p>"Sunrise valley" zinātnes un tehnoloģiju parks
    </p>
    <p>Reģistrācijas numurs: 3126224832
    </p>
    <p>Adrese : Saulėtekio al. 15, Viļņa, LT-10224
    </p>
    <p>Kontakti:
      <a target="_blank" href="https://ssmtp.lt/en/contacts/" rel="noopener noreferrer">https://ssmtp.lt/en/contacts/
      </a>
    </p>
    <p>The website www.innocape.eu is governed by Lithuanian law.
    </p>
  </section>
  <section>
    <h3>Satura nodrošinātāji
    </h3>
    <p>Vietnes saturu veido InnoCAPE projekta partneru komunikācijas komanda:
      <a target="_blank" href="https://innocape.eu/#partners" rel="noopener noreferrer">https://innocape.eu/#partners
      </a>
    </p>
  </section>
  <section>
    <h3>Autortiesības
    </h3>
    <p>© InnoCAPE, 2020
    </p>
    <p>Ja vien nav atrunāts citādi, tad, norādot avotu, attēlu, videoklipu un cita satura pavairošana ir atļauta
      nekomerciāliem mērķiem. Pretēji, ja ir jāsaņem iepriekšēja atļauja teksta un multivides (skaņas, attēlu,
      programmatūras utt.) reproducēšanai vai izmantošanai, šāda atļauja anulē iepriekš minēto vispārējo atļauju un
      skaidri norāda visus lietošanas ierobežojumus.
    </p>
  </section>
  <section>
    <h3>Ārējais saturs
    </h3>
    <p>InnoCAPE vietnē ir dažādas hipersaites uz ārējām vietnēm, kā arī integrēta dažādu sociālo mediju informācija.
      InnoCAPE nav atbildīgs par ārējo vietņu un sociālo mediju kontu kontekstu, ko nepārvalda InnoCAPE komunikācijas
      komanda.
    </p>
  </section>
  <section>
    <h3>Projekta vietnes
    </h3>
    <p>InnoCAPE vietnē ir izvietotas vairākas individuālas projekta apakšvietnes. Par šo vietņu saturu atbild projekta
      InnoCAPE vadošais partneris -
      <a target="_blank" href="https://ssmtp.lt/en" rel="noopener noreferrer">"Sunrise valley" zinātnes un tehnoloģiju
        parks
      </a>.
    </p>
  </section>
  <section>
    <h3>Uzturēšana
    </h3>
    <p>Vietni
      <a target="_blank" href="https://www.innocape.eu" rel="noopener noreferrer">www.innocape.eu
      </a> uztur "Telia Lietuva" AB, Viļņa, Lietuva (
      <a target="_blank" href="https://www.hostex.lt" rel="noopener noreferrer">www.hostex.lt
      </a>). Vietni
      <a target="_blank" href="https://dma.innocape.eu" rel="noopener noreferrer">dma.innocape.eu
      </a> (DMA) uztur SIA "CUBE Systems" (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>), Rīga, Latvija (
      <a target="_blank" href="https://www.cubesystems.lv" rel="noopener noreferrer">www.cubesystems.lv
      </a>). Vietni
      <a target="_blank" href="https://cmap.innocape.eu" rel="noopener noreferrer">cmap.innocape.eu
      </a> (CMAP) uztur SIA "Gstream" (
      <a target="_blank" href="https://www.easyhosting.lv" rel="noopener noreferrer">www.easyhosting.lv
      </a>), Rīga, Latvija.
    </p>
  </section>
</section>
<section>
  <h2>KONFIDENCIALITĀTES POLITIKA
  </h2>
  <p>Šī konfidencialitātes politika attiecas tikai uz InnoCAPE vietni un mikro vietnēm (apakšvietnēm). Ja jūs meklējiet
    informāciju kādā citā no vietnēm, jums vajadzētu iepazīties ar viņu konfidencialitātes politiku.
  </p>
  <p>InnoCAPE apņemas aizsargāt personas datus. Mēs darām visu iespējamo, lai jūsu personas datus apstrādātu saskaņā ar
    <a target="_blank" href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32016R0679"
      rel="noopener noreferrer">Vispārīgās datu aizsardzības regulu
    </a>. Šī konfidencialitātes politika izskaidro, kā mēs izmantojam personas datus, un kurus mēs no datiem ievācam
    brīdī, kad iesaistāties mūsu projektā, piemēram, izmantojot mūsu vietni, pievienojoties mūsu pasākumiem vai ieviešot
    projekta partneru izveidotos tiešsaistes rīkus.
  </p>
  <p>InnoCAPE apkopo to personu datus, kuri izmanto tiešsaistes rīkus un interneta vietni, kas paredzēta digitālā
    brieduma novērtējumam (DMA) un kompetences kartei (CMAP). Dati tiek apstrādāti ar pienācīgu rūpību un saskaņā ar
    visām Lietuvas Republikas piemērojamām prasībām, kas noteiktas likumā par personu tiesisko aizsardzību un datu
    pārvaldību.
  </p>
  <section>
    <h3>i) Apstrādātie personas dati un datu avoti
    </h3>
    <p>Lietojot InnoCAPE vietni tiek ievākta attiecīgā informācija: (i) lietotāja dati; un (ii) tehniskie dati. Lai gan
      mēs parasti neizmantojam tehniskos datus, lai identificētu personu kā indivīdu, dažreiz pēc tiem var atpazīt un
      precizēt lietotāja profilu. Šādās darbības ir saskaņā ar spēkā esošajiem likumiem - tehniskos datus var uzskatīt
      arī par personas datiem.
    </p>
    <p>Izmantojot InnoCAPE DMA vai CMAP, mēs varam savākt un apstrādāt šādus lietotāja datus: (i) vārds un uzvārds; (ii)
      adrese, (iii) tālruņa numurs, (iv) e-pasta adrese, (v) atrašanās vieta, brīdī, kad izmantoti mūsu pakalpojumi,
      (vi) izglītības iestāde vai īpašas prasmes, (vii) uzņēmuma dati (apraksts , vietnes adrese, sociālo mediju saites
      utt.).
    </p>
    <p>InnoCAPE var savākt lietotāja datus dažādos veidos, tostarp reģistrējoties mūsu pakalpojumiem vai tiešsaistes
      rīkiem, t.i., DMA un CMAP, piesakoties jaunākajām ziņām, reģistrējoties kādā no mūsu pasākumiem vai aizpildot
      tiešsaistes formas.
    </p>
    <p>InnoCAPE projekta partneri un/vai mūsu pilnvarotās trešās personas kā pakalpojumu sniedzēji var automātiski
      apkopot tehniskos datus brīdī, kad tiek apmeklēta vietne vai notiek mijiedarbība ar mūsu pakalpojumiem. Tehniskie
      dati var ietvert pārlūkprogrammas nosaukumu, datora vai ierīces veidu, vietnē pavadīto laiku, mijiedarbību ar
      pakalpojumiem, lietotāju apmeklējumu laiku un datumu, interneta vietņu lietošanas paradumus, IP adresi,
      operētājsistēmu un citu līdzīgu tehnisko informāciju.
    </p>
    <p>Mēs izmantojam dažādas tehnoloģijas, lai apkopotu un uzglabātu publisku informāciju brīdī, kad tiek izmantotas
      InnoCAPE DMA un CMAP vietnes (tostarp sīkfailus, Google tagus, analītiku u.c.).
    </p>
    <p>Sīkdatnes ļauj mums aprēķināt kopējo cilvēku skaitu, kas apmeklē mūsu tīmekļa vietnes, kā arī sniedz iespēju
      uzraudzīt vietnes izmantošanu. Arī mēs izmantojam sīkdatnes, kas jums kā lietotājam atvieglo vietnes lietošanu,
      piemēram, atceroties lietotājvārdus, paroles un valodas preferences. Tiek izmantoti izsekošanas un analīzes
      sīkfaili, lai redzētu, cik labi mūsu lietotāji saņem mūsu sniegtos pakalpojumus.
    </p>
    <p>Jūs variet izvēlēties iestatīt savu tīmekļa pārlūkprogrammu tā, lai atteiktos no sīkfailiem vai brīdinātu par
      tiem, kad tie tiek sūtīti. Ja plānojiet to darīt, ņemiet vērā, ka dažas no mūsu vietnes pakalpojumu daļām var
      nedarboties atbilstoši. Lai iegūtu papildinformāciju par sīkdatnēm un to dzēšanu, apmeklējiet vietni
      <a target="_blank" href="https://www.allaboutcookies.org" rel="noopener noreferrer">www.allaboutcookies.org
      </a>.
    </p>
    <p>Mūsu vietne izmanto Google Analytics un citus tīmekļa analīzes pakalpojumus (piemēram, Google tagu pārvaldnieku),
      lai apkopotu pārskatus par vietnes lietošanas paradumiem un palīdzētu mums uzlabot vietni un sniegtos
      pakalpojumus. Lai iegūtu pārskatu par Google Analytics, lūdzu, apmeklējiet vietni
      <a target="_blank" href="https://www.google.com/analytics/"
        rel="noopener noreferrer">http://www.google.com/analytics/
      </a>. Lai iegūtu pārskatu par Google tagu pārvaldnieku, lūdzu, apmeklējiet vietni
      <a target="_blank" href="https://support.google.com/tagmanager/answer/6102821?hl=en"
        rel="noopener noreferrer">https://support.google.com/tagmanager/answer/6102821?hl=en
      </a>
    </p>
  </section>
  <section>
    <h3>ii) Jūsu personas datu apstrādes mērķi un likumīgais pamatojums
    </h3>
    <p>InnoCAPE ietvaros personas datu apstrādei ir vairāki mērķi:
    </p>
    <p>Lai sniegtu mūsu pakalpojumus un pildītu vienošanos ar jums, InnoCAPE vispirms apstrādā jūsu personas datus, lai
      varētu piegādāt pakalpojumus. Šis process ietver datu apstrādi, kas iegūti, izmantojot digitālā brieduma
      novērtēšanas rīku depersonalizētā un apkopotā veidā, lai analizētu digitalizācijas stāvokli dažādās nozarēs un
      ģeogrāfiskajos apgabalos. Dati tiks izmantoti arī, lai sazinātos ar jums par iespēju saņemt papildu palīdzību no
      eksperta, ja to būsiet atzīmējis kā izvēli pēc digitālā brieduma novērtējuma.
    </p>
    <p>Personas datu apstrādes procedūra ir nepieciešama, lai veidotu komunikāciju ar klientu - sazinātos par mūsu
      pakalpojumiem un informētu par izmaiņām tajos. Jūsu dati tiks izmantoti arī izpētei un analīzei, kuru rezultātā
      tiks uzlaboti mūsu pakalpojumi un mūsu vietne. Dažos gadījumos, ja vien esat mums devis tam piekrišanu, vietnē
      ievadītos datus mēs varam izmantot, lai nosūtītu informāciju e-pastā par projektu.
    </p>
  </section>
  <section>
    <h3>iii) Saņēmēji
    </h3>
    <p>Personas dati var tikt kopīgoti InnoCAPE konsorcija ietvaros un Interreg Baltijas jūras reģiona programmas
      vadošajā iestādē/apvienotajā sekretariātā tikai tad, ja tas ir pamatoti nepieciešams mūsu pakalpojumu sniegšanai,
      attīstīšanai un projekta īstenošanai.
    </p>
    <section>
      <h4>Tas būtu nepieciešams konfidencialitātes politikas mērķiem
      </h4>
      <p>Ja trešajām pusēm ir nepieciešama piekļuve personas datiem, InnoCAPE veic atbilstošus līgumiskos un
        organizatoriskos pasākumus, lai nodrošinātu, ka jūsu dati tiek apstrādāti atbilstoši šī konfidencialitātes
        paziņojuma norādītajiem mērķiem un saskaņā ar visiem piemērojamajiem likumiem un noteikumiem. Mēs varam iesniegt
        jūsu personas datus mūsu filiālēs vai citos uzticamos uzņēmumos, lai tos apstrādātu, pamatojoties uz mūsu
        norādījumiem un saskaņā ar mūsu paziņojumu par konfidencialitāti un jebkuriem citiem atbilstošiem
        konfidencialitātes un drošības pasākumiem.
      </p>
    </section>
    <section>
      <h4>Juridisku apsvērumu dēļ
      </h4>
      <p>Mēs varam kopīgot jūsu personas datus ar trešajām pusēm, kuras ir ārpus InnoCAPE, ja mums ir pārliecība, ka
        piekļuve personas datiem un to izmantošana ir pamatoti nepieciešama, lai: (i) izpildītu visus piemērojamos
        likumus, noteikumus un / vai tiesas rīkojumus; (ii) atklātu, novērstu vai citādi risinātu krāpšanas, drošības
        vai tehniskas problēmas; un / vai (iii) saskaņā ar likumu tiktu aizsargāts InnoCAPE projekts, mūsu lietotāju vai
        sabiedrības intereses, manta vai drošība.
      </p>
    </section>
  </section>
  <section>
    <h3>iv) Datu glabāšanas termiņš
    </h3>
    <p>InnoCAPE neglabā jūsu personas datus ilgāk, kā tas ir likumā atļauts un nepieciešams mērķiem, kuriem dati tiek
      vākti. Uzglabāšanas laiks ir atkarīgs no informācijas rakstura un apstrādes mērķiem. Kamēr mēs uzturam mūsu vietni
      tiešsaistē, maksimālais tehnisko datu uzglabāšanas periods var atšķirties. Jūsu personas datus pakalpojumu
      sniegšanai mēs glabājam ne ilgāk kā piecus gadus pēc projekta beigām, kas DMA un CMAP rīkam tiek attiecināts līdz
      2021. gada oktobrim.
    </p>
  </section>
  <section>
    <h3>v) Jūsu tiesības
    </h3>
    <section>
      <h4>Tiesības piekļūt saviem datiem
      </h4>
      <p>InnoCAPE piedāvā piekļuvi mūsu apstrādātiem personas datiem. Tas nozīmē, ka jūs variet sazināties ar mums,
        lūdzot mūs informēt par jūsu apkopotajiem un apstrādātajiem personas datiem, kā arī mērķiem, kur dati tiek
        izmantoti.
      </p>
    </section>
    <section>
      <h4>Tiesības labot datus par sevi
      </h4>
      <p>Jums ir tiesības, ka, sazinoties ar mums, tiek izlaboti vai papildināti nepareizi, neprecīzi, nepilnīgi,
        novecojuši vai nevajadzīgi personas dati, kurus esam saglabājuši par jums.
      </p>
    </section>
    <section>
      <h4>Tiesības uz visu jūsu datu dzēšanu
      </h4>
      <p>Jūs variet arī lūgt mums izdzēst jūsu personas datus no mūsu sistēmām. Mēs izpildīsim šādus pieprasījumus, ja
        vien mums nav likumīga pamata neizdzēst tos.
      </p>
    </section>
    <section>
      <h4>Tiesības iebilst pret noteiktu jūsu datu izmantošanu
      </h4>
      <p>Jūs varat iebilst pret noteiktu jūsu personas datu izmantošanu, ja šie dati tiek apstrādāti citiem mērķiem, kas
        nav nepieciešami mūsu pakalpojumu sniegšanai vai juridisku pienākumu izpildei. Jūs varat arī iebilst pret
        jebkādu turpmāku jūsu personas datu apstrādi pēc iepriekšējas piekrišanas. Turpmāki iebildumi pret jūsu konkrētu
        personas datu apstrādi var izraisīt nepilnīgu mūsu sniegto pakalpojumu kvalitāti.
      </p>
    </section>
    <section>
      <h4>Right to restriction of processing of your personal data
      </h4>
      <p>You may request us to restrict certain processing of your personal data. If you restrict certain processing of
        your personal data, this may lead to poor service provided by us.
      </p>
    </section>
    <section>
      <h4>Tiesības uz datu pārnesamību
      </h4>
      <p>Jums ir tiesības saņemt no mums savus personas datus pilnā pamērā, lai pārsūtītu datus citam uzturētājam.
      </p>
    </section>
    <section>
      <h4>Kā izmantot savas tiesības?
      </h4>
      <p>Jūs variet izmantot augšup minētās tiesības, nosūtot mums vēstuli vai e-pastu, kurā jānorāda vārds, adrese,
        tālruņa numurs un derīgas identifikācijas kartes kopija uz iepriekš norādītajām adresēm. Ja uzskatāt, ka mūsu
        personas datu apstrādes darbības ir pretrunā ar piemērojamajiem datu aizsardzības likumiem, jums ir tiesības
        iesniegt sūdzību vietējā datu aizsardzības un uzraudzības iestādē.
      </p>
    </section>
  </section>
  <section>
    <h3>vi) Informācijas aizsardzība
    </h3>
    <p>Mēs veiksim visus atbilstošos drošības pasākumus, lai no nesankcionētas piekļuves vai izmaiņām, izpaušanas vai
      iznīcināšanas pasargātu mūsu rīcībā esošos personas datus. Piesardzības pasākumi ietver šifrēšanu, ugunsmūrus,
      drošas sistēmu piekļuves. Ja, neraugoties uz drošības pasākumiem rodas drošības pārkāpums, kam, iespējams, būs
      negatīva ietekme uz jūsu privātumu, mēs pēc iespējas ātrāk informēsim jūs par notikušo.
    </p>
  </section>
  <section>
    <h3>vii) Izmaiņas mūsu privātuma politikā
    </h3>
    <p>Konfidencialitātes politika primāri tika izstrādāta un publicēta angļu valodā, un tā laiku pa laikam var
      mainīties. Pašreizējo versiju varat atrast mūsu vietnē
      <a target="_blank" href="https://innocape.eu/privacy-policy/"
        rel="noopener noreferrer">https://innocape.eu/privacy-policy/
      </a>. Mēs paturam tiesības jebkurā laikā mainīt šo konfidencialitātes politiku. Visas izmaiņas tiks publicētas
      mūsu mājas lapā. Šī konfidencialitātes politika pēdējo reizi tika atjaunināta 2020. gada 1. decembrī.
    </p>
  </section>
</section>
<section>
  <h2>KĀ AR MUMS SAZINĀTIES:
  </h2>
  <p>Sunrise Valley Science and Technology Park
  </p>
  <p>Sauletekio ave. 15, LT-10224 Vilnius [Lithuania]
  </p>
  <p>Tel. + 370 640 56547
  </p>
  <p>Email: info@innocape.eu.
  </p>
</section>
`
